import { post } from '../axios'

// 添加banner
export function pdpBannerConfig_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_PDPBANNERCONFIG}/pdpBannerConfig/add`,
    map,
    option
  ).then(response => response)
}

// 修改排序
export function pdpBannerConfig_changeOrder_post(map, option) {
  return post(
    `${process.env.VUE_APP_PDPBANNERCONFIG}/pdpBannerConfig/changeOrder`,
    map,
    option
  ).then(response => response)
}

// 编辑banner
export function pdpBannerConfig_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_PDPBANNERCONFIG}/pdpBannerConfig/edit`,
    map,
    option
  ).then(response => response)
}

// banner配置列表
export function pdpBannerConfig_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_PDPBANNERCONFIG}/pdpBannerConfig/list`,
    map,
    option
  ).then(response => response)
}
